import { formatMoneyWithCurrency } from 'src/utils/formatter'
import './styles.scss'
import { Dropdown, Popup } from 'semantic-ui-react'
import { useMemo, useState } from 'react'
import moment from 'moment'
import FeatherIcon from 'feather-icons-react'
import { GetDataset, GetPorcentage } from 'src/components/dashboard/PanelVentas/functions'


export const DropdownResume = ({ companyId, totalAnnual, currentYear, period, period2, setPeriod, LastSales, Sales }) => {

  const periodsOptions = [
    {
      key: '2024',
      text: '2024',
      value: '2024'
    },
    {
      key: '2023',
      text: '2023',
      value: '2023'
    },
    {
      key: '2022',
      text: '2022',
      value: '2022'
    },
    {
      key: '2021',
      text: '2021',
      value: '2021'
    },
    {
      key: '2020',
      text: '2020',
      value: '2020'
    }
  ]

  const [hidden, setHidden] = useState('')
  const [specificPeriods, setSpecificPeriods] = useState("");

  const data = useMemo(() => {
    return [
      GetDataset({ companyId, source: LastSales, period, specificPeriods: '', isPast: true, hidden: 'past' }),
      GetDataset({ companyId, source: Sales, period, specificPeriods: '', isPast: false, hidden: 'present' }),
    ]
  }, [companyId, period, specificPeriods, Sales, LastSales, hidden])

  const porcentageData = GetPorcentage({ data })

  const totalPastYear = LastSales?.reduce((sum, month) => sum + month.sales, 0);

  const getCombinedSalesData = (lastSales, currentSales) => {
    const currentDate = moment();
    const currentMonth = currentDate.month() + 1; // moment.js usa 0-11, así que +1 para enero=1
  
    const safeLastSales = lastSales || [];
    const safeCurrentSales = currentSales || [];
  
    const combinedData = [...safeLastSales];
  
    for (let i = 0; i < currentMonth; i++) {
      if (safeCurrentSales[i]) {
        combinedData.push(safeCurrentSales[i]);
      }
    }

    return combinedData.reverse();
  };

  const combinedSalesData = getCombinedSalesData(LastSales, Sales);


  return (
    <>
      <div className="tw-px-7 tw-py-5 tw-flex tw-flex-col tw-gap-6">
        <div className='tw-flex tw-justify-between tw-items-center'>
          <p className="tw-font-medium tw-text-lg tw-text-gray-700 !tw-p-0 !tw-m-0">Detalles de la empresa</p>
          {/* <div>
            <Dropdown
              placeholder='Año'
              options={periodsOptions}
              className=''
              value={period}
              onChange={(e, { value }) => setPeriod(value)}
            />
          </div> */}
        </div>
        <div className="tw-flex tw-gap-6">
          <div className="tw-flex tw-flex-col tw-gap-6">
            <div className="tw-flex tw-gap-4">
              <div className="tw-w-[320px] tw-h-[76px] tw-rounded-md tw-px-5 tw-py-4 tw-bg-[#0099FF] tw-text-white tw-flex tw-flex-col tw-gap-1">
                <p className="tw-font-normal tw-text-sm !tw-p-0 !tw-m-0">Monto total Periodo {currentYear}</p>
                <p className="tw-font-medium tw-text-xl !tw-p-0 !tw-m-0">{formatMoneyWithCurrency(totalAnnual * 1000000)}</p>
              </div>
              <div className="tw-w-[320px] tw-h-[76px] tw-rounded-md tw-px-5 tw-py-4 tw-bg-purple-500 tw-text-white tw-flex tw-flex-col tw-gap-1">
                <p className="tw-font-normal tw-text-sm !tw-p-0 !tw-m-0">Monto total Periodo {period2}</p>
                <p className="tw-font-medium tw-text-xl !tw-p-0 !tw-m-0">{formatMoneyWithCurrency(totalPastYear * 1000000)}</p>
              </div>
            </div>
            <div>
              <div className="tw-w-[320px] tw-h-[76px] tw-rounded-md tw-px-5 tw-py-4 tw-bg-gray-100 tw-border-solid tw-border-[1px] tw-border-gray-200 tw-text-black">
                <div className='tw-flex tw-justify-between tw-items-center'>
                  <p className="tw-font-normal tw-text-sm !tw-p-0 !tw-m-0">Variación porcentual</p>
                  <Popup
                    inverted
                    trigger={<FeatherIcon icon="info" size={17} className="tw-cursor-pointer" />}
                    content={porcentageData?.footer}
                    position="top center"
                    className="!tw-text-sm"
                  />
                </div>
                <p className="tw-font-medium tw-text-xl !tw-p-0 !tw-m-0">{porcentageData?.porcentage}%</p>
              </div>
            </div>
          </div>
          <div className="tw-w-full tw-border-solid tw-border-[1px] tw-border-gray-300 tw-rounded-md">
            <div className="tw-w-full tw-bg-gray-200 tw-h-[40px] borderBgray tw-flex tw-justify-between tw-px-4 tw-items-center">
              <p className='!tw-p-0 !tw-m-0 tw-font-medium tw-text-black tw-text-sm'>Mes</p>
              <p className='!tw-p-0 !tw-m-0 tw-font-medium tw-text-black tw-text-sm'>Monto Neto</p>
            </div>
            <div className='tw-max-h-[280px] tw-overflow-y-auto'>
              {combinedSalesData?.map((item, index) => (
                <div key={index} className={`tw-w-full tw-h-[40px] ${index !== combinedSalesData.length - 1 ? 'borderBgray' : ''} tw-flex tw-px-4 tw-items-center tw-justify-between`}>
                  <p className='!tw-p-0 !tw-m-0 tw-font-light tw-text-black tw-text-sm tw-uppercase'>{moment(item.month).add(10, "hours").format('MMMM YYYY')}</p>
                  <p className='!tw-p-0 !tw-m-0 tw-font-light tw-text-black tw-text-sm'>{formatMoneyWithCurrency(item.sales * 1000000)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}